import { useMemo, useState } from "react";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import {
  accountRoutes,
  getAuthUser,
  getStoredAccountType,
  type AccountType,
} from "../auth";
import { UserProfilePage } from "./UserProfilePage";

const roleBadges: Record<AccountType, string> = {
  admin: "ADMIN",
  auditor: "AUDITEUR",
  hospital: "PRESTATAIRE",
  enterprise: "ENTREPRISE",
};

export function UserProfilePageRouter() {
  const { t } = useTranslation();
  const [accountType] = useState(() => getStoredAccountType());
  const labels = t.safecheck.settingsPage.userProfile;
  const authUser = getAuthUser();

  const config = useMemo(() => {
    const type = accountType ?? "admin";
    const hospitalLabels = labels.hospital;

    if (type === "hospital") {
      return {
        homeHref: accountRoutes.hospital,
        badge: hospitalLabels.badge,
        companySectionTitle: hospitalLabels.sections.providerInfo,
        companyNameLabel: hospitalLabels.fields.providerName,
        showOrgFields: true,
        initialUsername: authUser?.name ?? "",
        initialEmail: authUser?.email ?? "",
      };
    }

    if (type === "enterprise") {
      return {
        homeHref: accountRoutes.enterprise,
        badge: labels.badge,
        showOrgFields: true,
        initialUsername: authUser?.name ?? "",
        initialEmail: authUser?.email ?? "",
      };
    }

    return {
      homeHref: accountRoutes[type],
      badge: roleBadges[type],
      showOrgFields: false,
      initialUsername: authUser?.name ?? "",
      initialEmail: authUser?.email ?? "",
    };
  }, [accountType, authUser?.email, authUser?.name, labels]);

  return <UserProfilePage config={config} />;
}
